import Vue from 'vue';
import Vuex from 'vuex';

import authentication from './stores/authentication.js';
import games from './stores/games.js';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    authentication,
    games
  }
});

export default store;
